// Hund
export enum AnimalType {
  UNKNOWN = 'unknown',

  // Category: Dog
  DOG = 'dog',

  // Category: Cat
  CAT = 'cat',

  // Category: Horse
  PONY = 'pony',
  HORSE = 'horse',
  DONKEY = 'donkey',
  MULE = 'mule',

  // Category: Small Animals
  HAMSTER = 'hamster',
  HARE = 'hare',
  GUINEA_PIG = 'guinea_pig',
  CHINCHILLA = 'chinchilla',
  DEGU = 'degu',
  CHICKEN = 'chicken',
  WATERFOWL = 'waterfowl',
  PIGEON = 'pigeon',
  ORNAMENTAL_BIRD = 'ornamental_bird',
  PARRET = 'parret',
  FERRET = 'ferret',
  RODENT = 'rodent',
  TENREC = 'tenrec',
  DUCK = 'duck',
  GOOSE = 'goose',

  // Category: Wild Animals
  HEDGEHOG = 'hedgehog',
  RED_WILD = 'red_wild',
  BLACK_WILD = 'black_wild',
  MARTEN = 'marten',
  RACCOON = 'raccoon',
  CANIDS = 'canids',
  FELIDS = 'felids',
  WATERBIRD = 'waterbird',
  SONGBIRD = 'songbird',
  BIRD_OF_PREY = 'bird_of_prey',
  BEAR = 'bear',
  ELK = 'elk',
  CORVIDS = 'corvids',
  AMPHIBIAN = 'amphibian',

  // Category: Reptils
  SNAKE = 'snake',
  TURTLE = 'turtle',
  SPIDER = 'spider',
  LIZARD = 'lizard',
  SQUAMATE = 'squamate',

  // Category: Farm Animals
  GOAT = 'goat',
  SHEEP = 'sheep',
  PIG = 'pig',
  COW = 'cow',
  REINDEER = 'reindeer',
  CAMEL = 'camel',
  RATITE = 'ratite',
  ALPACA = 'alpaca'
}
